module.exports = __webpack_public_path__ + "img/dominant_back3.ed8f4b08.png";